import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import classNames from 'classnames';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import Menu from '@material-ui/core/Menu';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import DeleteIcon from '@material-ui/icons/Delete';
import DashboardIcon from '@material-ui/icons/Dashboard';
import DashboardOutlinedIcon from '@material-ui/icons/DashboardOutlined';
import ToggleOffIcon from '@material-ui/icons/ToggleOff';
import ToggleOnIcon from '@material-ui/icons/ToggleOn';
import EditIcon from '@material-ui/icons/Edit';
import AddBoxIcon from '@material-ui/icons/AddBox';
import LayersIcon from '@material-ui/icons/Layers';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ViewModuleIcon from '@material-ui/icons/ViewModule';
import { MdContentCopy } from 'react-icons/md';
import { MdContentPaste } from 'react-icons/md';

import { Link } from 'react-router-dom';
import SelectedCounter from '../../UI/SelectedCounter';
import IconButton from '../../UI/IconButton';
import BackButton from '../../UI/BackButton';
import SettingsButton from '../../UI/SettingsButton';
import FormDialog from '../../UI/FormDialog';
import PremiumFeature from '../../PremiumFeature';
import messages from './EditToolbar.messages';
import boardMessages from '../Board.messages';
import communicatorMessages from '../../Communicator/CommunicatorToolbar/CommunicatorToolbar.messages';
import './EditToolbar.css';
import { isCordova } from '../../../cordova-util';
import isMobile from 'ismobilejs';
import FullScreenButton from '../../UI/FullScreenButton';

class EditToolbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      boardsMenu: null,
      openTitleDialog: false,
      titleDialogValue:
        (props.currentCommunicator && props.currentCommunicator.name) ||
        (props.currentCommunicator && props.currentCommunicator.id) ||
        ''
    };
  }

  openBoardsMenu = e => {
    this.setState({ boardsMenu: e.currentTarget });
  };

  closeBoardsMenu = () => {
    this.setState({ boardsMenu: null });
  };

  handleSwitchBoard = board => {
    this.closeBoardsMenu();
    if (this.props.switchBoard) {
      this.props.switchBoard(board.id);
    }
    if (this.props.history) {
      this.props.history.replace(`/board/${board.id}`);
    }
  };

  handleCommunicatorTitleClick = () => {
    if (!this.props.isLoggedIn) return;
    if (!this.isCommunicatorTitleClicked) {
      this.isCommunicatorTitleClicked = setTimeout(() => {
        this.isCommunicatorTitleClicked = false;
      }, 400);
    } else {
      this.setState({
        openTitleDialog: true,
        titleDialogValue:
          (this.props.currentCommunicator &&
            this.props.currentCommunicator.name) ||
          (this.props.currentCommunicator &&
            this.props.currentCommunicator.id) ||
          ''
      });
    }
  };

  handleCommunicatorTitleChange = event => {
    this.setState({ titleDialogValue: event.target.value });
  };

  handleCommunicatorTitleSubmit = async () => {
    if (this.state.titleDialogValue.length && this.props.editCommunicatorTitle) {
      try {
        await this.props.editCommunicatorTitle(this.state.titleDialogValue);
      } catch (e) {}
    }
    this.handleCommunicatorTitleClose();
  };

  handleCommunicatorTitleClose = () => {
    this.setState({
      openTitleDialog: false,
      titleDialogValue:
        (this.props.currentCommunicator &&
          this.props.currentCommunicator.name) ||
        (this.props.currentCommunicator &&
          this.props.currentCommunicator.id) ||
        ''
    });
  };

  boardCaption = board => {
    if (isCordova() && board.caption && board.caption.search('/') === 0) {
      return `.${board.caption}`;
    }
    return board.caption;
  };

  render() {
    const {
      board,
      className,
      intl,
      isSelectAll,
      isSelecting,
      isSaving,
      isLoggedIn,
      selectedItemsCount,
      onSelectClick,
      onDeleteClick,
      onEditClick,
      onSelectAllToggle,
      onBoardTitleClick,
      onAddClick,
      onCopyTiles,
      onPasteTiles,
      copiedTiles,
      communicatorBoards,
      openCommunicatorDialog,
      disableBackButton,
      onBackClick,
      logoUrl,
      appName,
      license,
      toolbarLayout,
      bigTileMode,
      onBigTileModeToggle,
    } = this.props;

    const isItemsSelected = !!selectedItemsCount;

    return (
      <div
        className={classNames('EditToolbar', className, {
          'EditToolbar--selecting': isSelecting
        })}
      >
        {/* Side-by-side: license section with divider on the far left */}
        {toolbarLayout === 'sidebyside' && license && (
          <div className="EditToolbar__license-section">
            <span>{intl.formatMessage(boardMessages.license)}: {license.license}</span>
            <span className="EditToolbar__divider" />
          </div>
        )}
        {/* CENTER: Logo + App name + Boards dropdown + Board title */}
        {(logoUrl || appName) && (
          <div className="EditToolbar__branding" style={{ display: 'flex', alignItems: 'center', gap: 8, order: 2, padding: '0 8px' }}>
            {logoUrl && (
              <img
                src={logoUrl}
                alt=""
                style={{ height: 28, width: 'auto', objectFit: 'contain' }}
                onError={e => { e.target.style.display = 'none'; }}
              />
            )}
            {appName && (
              <span style={{
                fontSize: '1rem',
                fontWeight: 600,
                color: 'var(--site-toolbar-icon-color, #fff)',
                textTransform: 'uppercase',
                whiteSpace: 'nowrap'
              }}>
                {appName}
              </span>
            )}
          </div>
        )}
        <Button
          className="EditToolbar__BoardsButton"
          id="boards-button"
          disabled={
            isSelecting ||
            !communicatorBoards ||
            communicatorBoards.length === 0
          }
          onClick={this.openBoardsMenu}
        >
          <ArrowDropDownIcon />
          <FormattedMessage {...communicatorMessages.boards} />
        </Button>
        <Menu
          id="boards-menu"
          className="CommunicatorToolbar__menu"
          anchorEl={this.state.boardsMenu}
          open={Boolean(this.state.boardsMenu)}
          onClose={this.closeBoardsMenu}
        >
          {communicatorBoards &&
            communicatorBoards.map(b => (
              <ListItem
                className="CommunicatorToolbar__menuitem"
                key={b.id}
                onClick={() => this.handleSwitchBoard(b)}
              >
                <ListItemAvatar>
                  {this.boardCaption(b) ? (
                    <Avatar src={this.boardCaption(b)} />
                  ) : (
                    <Avatar>
                      <ViewModuleIcon />
                    </Avatar>
                  )}
                </ListItemAvatar>
                <ListItemText
                  inset
                  primary={b.name || b.nameKey || ''}
                  secondary={intl.formatMessage(communicatorMessages.tiles, {
                    qty: b.tiles.length
                  })}
                />
              </ListItem>
            ))}
        </Menu>

        <FormDialog
          open={this.state.openTitleDialog}
          title={<FormattedMessage {...communicatorMessages.editTitle} />}
          onSubmit={this.handleCommunicatorTitleSubmit}
          onClose={this.handleCommunicatorTitleClose}
        >
          <TextField
            autoFocus
            margin="dense"
            label={
              <FormattedMessage {...communicatorMessages.communicatorTitle} />
            }
            value={this.state.titleDialogValue}
            type="text"
            onChange={this.handleCommunicatorTitleChange}
            fullWidth
            required
          />
        </FormDialog>

        {(isSaving || !isLoggedIn) && (
          <span className="EditToolbar__BoardTitle">{board?.name}</span>
        )}

        {!isSaving && isLoggedIn && (
          <Button
            className={classNames('EditToolbar__BoardTitle', {
              'logged-in': isLoggedIn
            })}
            onClick={onBoardTitleClick}
          >
            {board.name}
          </Button>
        )}

        {/* LEFT: Back + Build + Edit buttons */}
        <div className="EditToolbar__group EditToolbar__group--start">
          <BackButton
            disabled={disableBackButton || isSelecting || isSaving}
            onClick={onBackClick}
          />

          {/* Compact: license label inline after back button */}
          {toolbarLayout === 'compact' && license && (
            <span className="EditToolbar__license">
              {intl.formatMessage(boardMessages.license)}: {license.license}
            </span>
          )}

          <IconButton
            label={intl.formatMessage(communicatorMessages.editCommunicator)}
            disabled={isSelecting || isSaving}
            onClick={openCommunicatorDialog}
          >
            <LayersIcon />
          </IconButton>

          <IconButton
            label={intl.formatMessage(
              messages[isSelecting ? 'cancel' : 'editTilesButton']
            )}
            disabled={isSaving}
            onClick={onSelectClick}
          >
            {isSelecting ? (
              <DashboardOutlinedIcon />
            ) : (
              <DashboardIcon />
            )}
          </IconButton>

          {isSaving && (
            <CircularProgress
              size={24}
              className="EditToolbar__Spinner"
              thickness={7}
            />
          )}
        </div>

        {/* RIGHT: Add tile / selection controls */}
        <div className="EditToolbar__group EditToolbar__group--end">
          {isSelecting && (
            <Fragment>
              <Checkbox checked={isSelectAll} onChange={onSelectAllToggle} />
              <SelectedCounter
                count={selectedItemsCount}
                className="EditToolbar__SelectedCounter"
              />

              <IconButton
                label={intl.formatMessage(messages.deleteTiles)}
                disabled={!isItemsSelected}
                onClick={onDeleteClick}
              >
                <DeleteIcon />
              </IconButton>
              <PremiumFeature>
                <IconButton
                  label={intl.formatMessage(messages.copyTiles)}
                  disabled={!isItemsSelected}
                  onClick={onCopyTiles}
                >
                  <MdContentCopy />
                </IconButton>
                <IconButton
                  label={intl.formatMessage(messages.pasteTiles)}
                  disabled={!copiedTiles.length}
                  onClick={onPasteTiles}
                >
                  <MdContentPaste />
                </IconButton>
              </PremiumFeature>
              <IconButton
                label={intl.formatMessage(messages.editTiles)}
                disabled={!isItemsSelected}
                onClick={onEditClick}
              >
                <EditIcon />
              </IconButton>
            </Fragment>
          )}
          {!isSelecting && (
            <div className={'add__board__tile'}>
              <IconButton
                label={intl.formatMessage(messages.addTileButton)}
                onClick={onAddClick}
                disabled={isSaving}
                color="inherit"
              >
                <AddBoxIcon />
              </IconButton>
              <IconButton
                label={intl.formatMessage(
                  messages[bigTileMode ? 'compactTileMode' : 'bigTileMode']
                )}
                onClick={onBigTileModeToggle}
                disabled={isSaving}
              >
                {bigTileMode ? <ToggleOnIcon /> : <ToggleOffIcon />}
              </IconButton>
            </div>
          )}
          {!isMobile.any && <FullScreenButton />}
          <SettingsButton component={Link} to="/settings" />
        </div>
      </div>
    );
  }
}

EditToolbar.propTypes = {
  className: PropTypes.string,
  intl: intlShape.isRequired,
  isSelectAll: PropTypes.bool,
  isSelecting: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  isSaving: PropTypes.bool,
  selectedItemsCount: PropTypes.number.isRequired,
  onSelectClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  onEditClick: PropTypes.func,
  onSelectAllToggle: PropTypes.func,
  onBoardTitleClick: PropTypes.func,
  board: PropTypes.object,
  onAddClick: PropTypes.func,
  onBoardTypeChange: PropTypes.func,
  copiedTiles: PropTypes.arrayOf(PropTypes.object),
  communicatorBoards: PropTypes.array,
  currentCommunicator: PropTypes.object,
  openCommunicatorDialog: PropTypes.func,
  switchBoard: PropTypes.func,
  editCommunicatorTitle: PropTypes.func,
  history: PropTypes.object,
  disableBackButton: PropTypes.bool,
  onBackClick: PropTypes.func,
  bigTileMode: PropTypes.bool,
  onBigTileModeToggle: PropTypes.func
};

export default injectIntl(EditToolbar);
